import { useTranslation } from "react-i18next";

import AssetTypeCategory from "@/modules/asset-type/asset-type-category";
import { AssetTypesListTableRowActions } from "@/modules/asset-types/asset-types-list-table";
import ListTable from "@/modules/list-table";
import { ModelLink } from "@/modules/model-link";
import {
  getTableFilterQueryable,
  TABLE_FILTER_TEXT,
} from "@/modules/table-filter";
import { format } from "@/utilities/date";

const AssetTypesTable = (listTableProps) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("global:name"),
      dataIndex: "name",
      render: (_name, assetType) => (
        <ModelLink model="assettype" item={assetType} />
      ),
      sorter: true,
      fixed: "left",
      minWidth: 220,
      ...TABLE_FILTER_TEXT,
    },
    {
      title: t("global:assetPlural"),
      dataIndex: "assets_count",
    },
    {
      title: t("assetType:form.technicalForm.label"),
      dataIndex: "entity_template_id",
      render: (_, { entity_template }) => entity_template?.name || "",
      ...getTableFilterQueryable({ model: "entityTemplates" }),
    },
    {
      title: t("assetType:form.category.label"),
      dataIndex: "asset_type_category",
      render: (_, assetType) => <AssetTypeCategory assetType={assetType} />,
      ...getTableFilterQueryable({
        model: "referential.assetTypeCategories",
        filterBy: "slug",
        primaryKey: "slug",
      }),
    },
    {
      title: t("global:lastUpdate"),
      dataIndex: "updated_at",
      sorter: true,
      render: (value) => format(value),
    },
    {
      title: "",
      fixed: "right",
      render: (assetType) => (
        <AssetTypesListTableRowActions assetType={assetType} />
      ),
    },
  ];

  return <ListTable columns={columns} {...listTableProps} />;
};

export default AssetTypesTable;
